import { Box, SxProps } from "@mui/material";
import { FC } from "react";
import { theme } from "../../../theme";
import { lastColumnStyles } from "../Common.styles";
interface CellBoxProps {
  sx?: SxProps;
  firstCol?: boolean;
  lastCol?: boolean;
  stickyFirstCol?: boolean;
  contentPosition?: string;
  contentDirection?: "column" | "row";
  children: React.ReactNode;
}

const CellBox: FC<CellBoxProps> = ({
  sx,
  children,
  firstCol,
  lastCol,
  stickyFirstCol = false,
  contentPosition,
  contentDirection = "row",
}) => {
  return (
    <Box
      sx={{
        ...(firstCol && stickyFirstCol && {
          position: "sticky",
          left: 0,
          backgroundColor: theme.palette.background.paper,
          boxShadow: `2px 0 4px -2px ${theme.palette.grey[300]}`,
        }),
        ...(lastCol && lastColumnStyles(theme)),
        paddingLeft: theme.spacing(2),
        height: "100%",
        display: "flex",
        flexDirection: contentDirection,
        alignItems: "center",
        justifyContent: contentPosition
          ? `${contentPosition}!important`
          : "center",
        minWidth: "0",
        ...sx,
        "& p ": {
          maxWidth: "100%",
          overflow: "hidden",
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
        },
      }}
    >
      {children}
    </Box>
  );
};

export default CellBox;
